import React, { Suspense } from 'react'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'
import FaberGlobalUserSearch from 'pages/OTPacks/Global/components/FaberGlobalUserSearch'

export default function FaberGlobalDashboard() {
  return (
    <>
      <Suspense fallback={<LayoutSkeleton />}>
        <FaberGlobalUserSearch />
      </Suspense>
    </>
  )
}
